import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Box, Button, TextField, Typography, Grid } from "@material-ui/core";
import { PanTool, Send } from "@material-ui/icons";

import { requestStop } from "../../../reducer/studentResearch/action";
import { uploadMultiFile } from "../../../reducer/file/action";
import MultiFileManager from "../../File/MultiFileManager/MultiFileManager";
import select from "../../../utils/select";
import SectionCard from "./SectionCard";

export default function RequestStopForm({ detail, onDone }) {
  const dispatch = useDispatch();
  const profileDetail = useSelector((s) => select(s, "profileReducer", "detail"));
  const [reason, setReason] = useState("");
  // BE lưu leaveFileLink là string đơn (hoặc nhiều URL nối "||"). FE giữ array
  // để hiển thị/edit qua MultiFileManager, join lại khi gửi BE.
  const [fileUrls, setFileUrls] = useState([]);
  const [newFiles, setNewFiles] = useState([]);
  const [saving, setSaving] = useState(false);

  // Upload pending files, merge với URLs hiện có, trả về string "||"-joined.
  // BE endpoint /file/storage/multi/{id} chỉ accept type thuộc enum — dùng
  // "studentResearch" cho module này.
  const commitFiles = async () => {
    if (!newFiles || newFiles.length === 0) return fileUrls.join("||");
    const ownerId = profileDetail?.id || 0;
    const result = await dispatch(uploadMultiFile(ownerId, newFiles, "studentResearch"));
    if (result?.success && Array.isArray(result.data)) {
      const merged = [...fileUrls, ...result.data];
      setFileUrls(merged);
      setNewFiles([]);
      return merged.join("||");
    }
    return fileUrls.join("||");
  };

  const handleSubmit = async () => {
    if (!reason.trim()) {
      alert("Vui lòng nhập lý do xin dừng.");
      return;
    }
    setSaving(true);
    try {
      const fileLink = await commitFiles();
      const ok = await dispatch(requestStop(detail.id, reason, fileLink));
      if (ok && onDone) onDone();
    } finally {
      setSaving(false);
    }
  };

  return (
    <Box padding="16px 24px">
      <SectionCard icon={<PanTool />} title="Xin dừng thực hiện đề tài" marginTop={0}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography variant="body2" style={{ marginBottom: 6 }}>
              <b>Lý do xin dừng</b> <span style={{ color: "#c62828" }}>*</span>
            </Typography>
            <TextField
              fullWidth multiline minRows={4}
              variant="outlined"
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              disabled={saving}
            />
          </Grid>
          <Grid item xs={12}>
            <Typography variant="body2" style={{ marginBottom: 6 }}>
              <b>File đơn xin dừng (PDF/DOCX)</b>
            </Typography>
            <MultiFileManager
              fileUrls={fileUrls}
              setFileUrls={setFileUrls}
              newFiles={newFiles}
              setNewFiles={setNewFiles}
              disabled={saving}
            />
          </Grid>
        </Grid>
      </SectionCard>

      <Box
        marginTop={3} paddingTop={2}
        display="flex" justifyContent="flex-end"
        borderTop="solid 1px #e0e0e0"
      >
        <Button
          variant="contained" color="secondary"
          onClick={handleSubmit} disabled={saving}
          startIcon={<Send />}
        >
          Gửi đơn xin dừng
        </Button>
      </Box>
    </Box>
  );
}
